import React from "react";
import { Link } from "react-router";
import axios from "axios";

export default class Intro extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_state: null
    };
  }

  handleSubmit = () => {
    axios
      .patch("/v1/users/self/", {
        onboarding_state: APP_CONFIG.onboarding_state
      })
      .then((response) => {
        window.location = "/";
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentWillMount() {
    axios
      .get("/v1/users/self/")
      .then((response) => {
        this.setState({
          onboarding_state: response.data.onboarding_state
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    return (
      <div className="content-container text-only">
        <div className="section-top">
          <h1>Privacy- en cookiebeleid NIBHV</h1>
        </div>

        <div className="content">
          <p>Dit is het Privacy- en cookiebeleid van NIBHV, waarin je kunt nalezen hoe NIBHV met je privacy omgaat.</p>
          <p>
            NIBHV werd in 1999 opgericht door het Instituut Fysieke Veiligheid en Het Oranje Kruis. Sindsdien is NIBHV uitgegroeid tot hét kennisinstituut voor
            bedrijfshulpverlening in Nederland. Ook deelt zij haar expertise in bedrijfsnoodorganisaties, brand- en arbeidsveiligheid in Nederland. Zij helpt bij het
            bewust veilig werken binnen iedere organisatie. Met 25 collega’s ontwikkelt zij lesplannen en –materialen, en kwalitatieve leerstof voor
            bedrijfsveiligheidscursussen. Van bhv tot aan het niveau van de wettelijk aangewezen bedrijfsbrandweer.
          </p>
          <p>
            Meer informatie over wat NIBHV doet vind je op onze{" "}
            <a href="https://www.nibhv.nl" target="_blank">
              website
            </a>
            .
          </p>

          <h2>Voor wie is dit privacy- en cookiebeleid bedoelt?</h2>
          <p>
            Dit privacy- en cookiebeleid is bedoeld voor bezoekers aan en gebruikers van de NIBHV website, het NIBHV Opleidersportaal en de Mijn NIBHV-omgeving, voor
            klanten die producten van NIBHV afnemen, voor cursisten van wie NIBHV (cursus)gegevens opslaat, voor opleiders, voor instructeurs, en voor examinatoren.
          </p>

          <h2>Verantwoordelijke voor de verwerking van je persoonsgegevens</h2>
          <p>
            NIBHV B.V. (Nederlands Instituut voor Bedrijfshulpverlening), Hoofdweg 240 (3067 GJ) Rotterdam, is de verwerkingsverantwoordelijke voor de verwerking van je
            persoonsgegevens.
          </p>

          <h2>Contact met NIBHV</h2>
          <p>Je kunt als volgt contact opnemen met NIBHV:</p>
          <ul>
            <li>Via de contactpagina(s) op de NIBHV-website(s);</li>
            <li>per e-mail via info@nibhv.nl • per telefoon via 010 – 289 28 88</li>
            <li>per post naar NIBHV, Postbus 8714, 3009 AS Rotterdam</li>
            <li>per post naar NIBHV, Antwoordnummer 91073, 3009 WB Rotterdam</li>
          </ul>

          <h2>Verwerkte persoonsgegevens bij bezoek aan NIBHV website(s) en app(s)</h2>
          <p>
            Bij je bezoek aan onze website(s), mobiele website(s) en app(s) kan NIBHV, afhankelijk van de doeleinden van de verwerking, de volgende persoonsgegevens van
            jou verwerken:
          </p>
          <ul>
            <li>naam</li>
            <li>geboortedatum</li>
            <li>geslacht</li>
            <li>contactgegevens (adres, telefoonnummer)</li>
            <li>e-mailadres</li>
            <li>gegevens over je bezoek aan onze website(s), mobiele website(s) en app(s), zoals URL, IP-adres, browsertype, taal, datum en tijd van je bezoek</li>
            <li>gegevens over je interesses als gebruiker van onze website(s), producten en diensten</li>
            <li>locatiegegevens</li>
            <li>koppelingen met social media</li>
            <li>gegevens over je aankopen op onze website(s)</li>
            <li>financiële gegevens in verband met bestellingen en betalingen</li>
            <li>door jouw verstrekte informatie zoals functie, werkgever, titel, branche, bedrijf, regio</li>
            <li>door jou bij registratie verstrekte gegevens zoals je gebruikersnaam en je wachtwoord</li>
            <li>gegevens betreffende je NIBHV examinatorbevoegdheden</li>
            <li>gegevens betreffende door jouw gevolgde NIBHV cursussen</li>
            <li>gegevens betreffende je NIBHV-certificering</li>
            <li>gegevens betreffende door jou gevolgde cursussen en afgelegde en behaalde toetsen</li>
          </ul>

          <h2>Verwerking persoonsgegevens in het NIBHV Portaal</h2>
          <p>In het kader van het NIBHV Portaal kan NIBHV, afhankelijk van de doeleinden van de verwerking, de volgende persoonsgegevens van jou verwerken:</p>
          <ul>
            <li>naam</li>
            <li>geboortedatum</li>
            <li>geslacht</li>
            <li>contactgegevens (adres, telefoonnummer)</li>
            <li>e-mailadres</li>
            <li>gegevens over je bezoek aan NIBHV Portaal, zoals inloggegevens, URL, IP-adres, browsertype, taal, datum en tijd van je bezoek</li>
            <li>gegevens over je gebruik van NIBHV Portaal</li>
            <li>locatiegegevens</li>
            <li>financiële gegevens</li>
            <li>door jou verstrekte informatie zoals functie, werkgever, titel, branche, bedrijf, regio</li>
            <li>door jou bij registratie verstrekte gegevens zoals je gebruikersnaam en je wachtwoord</li>
            <li>je bevoegdheden als instructeur</li>
            <li>je activiteiten als instructeur</li>
            <li>je bevoegdheden als examinator</li>
            <li>je activiteiten als examinator</li>
            <li>gegevens betreffende je NIBHV-certificering</li>
            <li>gegevens over opleidingen die je gaat volgen of hebt gevolgd</li>
            <li>gegevens over door jou afgelegde toetsen</li>
            <li>je competentieprofiel (afgeleid uit de door jou gevolgde opleidingen en afgelegde toetsen, en de voortgang daarin</li>
            <li>Gegevens over de door jou of jouw werkgever gesloten verzekeringen behorend bij je competentieprofiel?</li>
          </ul>

          <h2>Verwerking persoonsgegevens in Mijn NIBHV</h2>
          <p>In het kader van de Mijn NIBHV-omgeving kan NIBHV, afhankelijk van de doeleinden van de verwerking, de volgende persoonsgegevens van jou verwerken:</p>

          <ul>
            <li>naam</li>
            <li>geboortedatum</li>
            <li>e-mailadres</li>
            <li>gegevens over je bezoek aan Mijn NIBHV, zoals inloggegevens, URL, IP-adres, browsertype, taal, datum en tijd van je bezoek</li>
            <li>gegevens over je gebruik van Mijn NIBHV</li>
            <li>door je bij registratie verstrekte gegevens zoals je gebruikersnaam en je wachtwoord</li>
            <li>gegevens over opleidingen die je gaat volgen of hebt gevolgd</li>
            <li>gegevens betreffende je NIBHV-certificering</li>
            <li>gegevens over door jou afgelegde toetsen</li>
            <li>je competentieprofiel (afgeleid uit de door jouw gevolgde opleidingen en afgelegde toetsen en de voortgang daarin</li>
            <li>Gegevens over de door jou of jouw werkgever gesloten verzekeringen behorend bij je competentieprofiel</li>
          </ul>

          <h2>Doeleinden verwerking persoonsgegevens</h2>
          <p>Je persoonsgegevens kunnen verwerkt worden voor de volgende doeleinden:</p>
          <ul>
            <li>voor de totstandkoming en uitvoering van met jou gesloten overeenkomsten</li>
            <li>om je de overeengekomen diensten, producten en informatie te leveren</li>
            <li>om contact met je op te nemen over de door jouw gevraagde diensten</li>
            <li>om je rol als NIBHV-examinator/instructeur mogelijk te maken en te faciliteren</li>
            <li>om deelname aan NIBHV-cursussen mogelijk te maken en certificeringen te registreren</li>
            <li>om de registratie van door jouw gevolgde cursussen en afgelegde en behaalde toetsen mogelijk te maken</li>
            <li>om je te informeren over huidige en toekomstige producten of diensten van NIBHV</li>
            <li>om je uitnodigingen te sturen voor congressen en dergelijke, en je aanmelding daarvoor te verwerken</li>
            <li>om je aanbiedingen van andere organisaties te sturen, als je daarvoor toestemming hebt gegeven</li>
            <li>om deelname mogelijk te maken aan acties</li>
            <li>om onze website(s), informatie, producten, diensten en aanbiedingen zo veel mogelijk op je interesses af te stemmen</li>
            <li>om je toegang te verlenen tot onze website(s) en apps, al dan niet op basis van je registratie als gebruiker</li>
            <li>om de kwaliteit, veiligheid en gebruiksvriendelijkheid van onze dienstverlening en onze (mobiele) websites en apps te verbeteren</li>
            <li>om markt- en statistisch onderzoek uit te voeren</li>
            <li>om te voldoen aan wet- en regelgeving</li>
            <li>om de kwaliteit van de bedrijfshulpverlening en de veiligheid in bedrijven en andere organisaties te bevorderen</li>
          </ul>

          <p>In het kader van NIBHV Portaal kan NIBHV je persoonsgegevens verwerken:</p>
          <ul>
            <li>om je rol als opleider, instructeur of examinator mogelijk te maken en te faciliteren</li>
            <li>om contact met je op te kunnen nemen</li>
            <li>om deelname aan opleidingen mogelijk te maken en certificeringen te registreren</li>
            <li>om de registratie van door jou gevolgde opleidingen en afgelegde en behaalde examens mogelijk te maken</li>
            <li>om een zo compleet mogelijk beeld te verschaffen van de (voortgang in) de relevante competenties van cursisten</li>
            <li>om je toegang te verlenen tot NIBHV Portaal</li>
            <li>om de kwaliteit, veiligheid en gebruiksvriendelijkheid van het NIBHV Portaal te verbeteren</li>
            <li>om markt- en statistisch onderzoek uit te voeren</li>
            <li>om te voldoen aan wet- en regelgeving</li>
            <li>
              om de doelstellingen van NIBHV te behalen: het bevorderen van de kwaliteit van de bedrijfshulpverlening en de veiligheid in bedrijven en andere organisaties
            </li>
          </ul>

          <p>In het kader van Mijn NIBHV kan NIBHV je persoonsgegevens verwerken:</p>
          <ul>
            <li>om contact met je op te kunnen nemen</li>
            <li>om je toegang te verlenen tot Mijn NIBHV</li>
            <li>om de kwaliteit, veiligheid en gebruiksvriendelijkheid van de Mijn NIBHV te verbeteren</li>
            <li>om deelname aan cursussen mogelijk te maken en certificeringen te registreren</li>
            <li>om de registratie van door jou gevolgde cursussen en afgelegde toetsen mogelijk te maken</li>
            <li>om je een zo compleet mogelijk beeld te verschaffen van (je voortgang in) de voor jou relevante competenties</li>
            <li>om je te informeren over huidige en toekomstige producten of diensten van NIBHV</li>
            <li>om je uitnodigingen te sturen voor congressen en dergelijke, en je aanmelding daarvoor te verwerken</li>
            <li>om je aanbiedingen van andere organisaties te sturen, als je daarvoor toestemming hebt gegeven</li>
            <li>om deelname mogelijk te maken aan acties</li>
            <li>om markt- en statistisch onderzoek uit te voeren</li>
            <li>om te voldoen aan wet- en regelgeving</li>
            <li>
              om de doelstellingen van NIBHV te behalen: het bevorderen van de kwaliteit van de bedrijfshulpverlening en de veiligheid in bedrijven en andere organisaties
            </li>
          </ul>
          <p>Je persoonsgegevens zullen niet worden gebruikt voor andere dan de hierboven genoemde doeleinden.</p>

          <h2>Rechtsgronden voor de verwerking van je persoonsgegevens</h2>
          <p>NIBHV verwerkt je persoonsgegevens omdat zij daarvoor, in de woorden van de Algemene verordening gegevensbescherming, een ‘gerechtvaardigd belang’ heeft.</p>
          <p>
            Dat houdt in dat wij je gegevens mogen verwerken omdat dat nodig is voor onze bedrijfsuitoefening, zolang je privacybelangen niet in de knel komen. We mogen
            dat ook doen in het belang van anderen, zoals onze klanten. In bepaalde gevallen verwerken wij je persoonsgegevens voor de uitvoering van een met jouw
            gesloten overeenkomst, of om wettelijke bepalingen (bijvoorbeeld op het gebied van administratie en belastingen) na te leven. Als we voor de verwerking van
            bepaalde persoonsgegevens je toestemming nodig hebben zullen we die gegevens pas verwerken als we je toestemming hebben gekregen, en zullen we daarmee stoppen
            als je die toestemming intrekt.
          </p>

          <h2>Hoe komen wij aan je persoonsgegevens?</h2>
          <p>
            Wij kunnen de beschikking krijgen over je persoonsgegevens omdat je die zelf aan ons verstrekt, bijvoorbeeld bij het sluiten van een overeenkomst met NIBHV,
            het doen van een bestelling op onze website, of bij het inloggen in NIBHV Portaal of in Mijn NIBHV. Daarnaast kunnen wij je persoonsgegevens ontvangen van
            opleiders waar je een door NIBHV geregistreerde cursus gaat volgen of gevolgd hebt.
          </p>

          <h2>Websites van derden</h2>
          <p>
            Met uitzondering van websites van derden die NIBHV als verwerker inschakelt, is dit privacy- en cookiebeleid niet van toepassing op de websites van derden
            waarnaar NIBHV op zijn website(s) een hyperlink aanbiedt. NIBHV is niet verantwoordelijk voor de gegevensverwerking of het privacybeleid van deze derden.
          </p>

          <h2>Verwerkers</h2>
          <p>
            Voorzover NIBHV voor de in dit privacy- en cookiebeleid vermelde doeleinden gebruik maakt van de diensten van derden en deze derden bij het uitvoeren van de
            betreffende diensten toegang hebben tot persoonsgegevens, heeft NIBHV de vereiste contractuele en organisatorische maatregelen getroffen om te verzekeren dat
            je gegevens uitsluitend voor de hier omschreven doeleinden worden verwerkt.
          </p>

          <h2>Gegevensverwerking in Nederland en in het buitenland</h2>
          <p>Je persoonsgegevens worden opgeslagen en verwerkt in Nederland of in landen waarvoor dit is toegestaan op grond van de Nederlandse wetgeving.</p>

          <h2>Cookies</h2>
          <p>
            Voor het verzamelen van gegevens gebruikt NIBHV cookies. Cookies zijn kleine tekstbestanden die op de harde schijf of in het geheugen van je computer worden
            opgeslagen. Cookies worden bijvoorbeeld gebruikt om je favoriete instellingen voor een bepaalde dienst, webpagina of website bij te houden. Cookies kunnen ook
            worden gebruikt om te voorkomen dat je een bepaalde advertentie te vaak te zien krijgt en om het aantal keren dat een advertentie wordt weergegeven te
            registreren. Als het niet noodzakelijk is om persoonlijke gegevens in een cookie op te slaan, zal NIBHV dat niet doen.
          </p>
          <p>
            Bij je bezoek aan websites wordt je gevraagd toestemming te geven voor het gebruik van cookies. Indien je die toestemming geeft (door op ‘Akkoord’ te klikken
            of door verder te gaan met je bezoek aan de website) kunnen de hieronder beschreven cookies worden geplaatst. Wilt je geen cookies accepteren, dan kan je dit
            altijd zelf aangeven in je browser. Meer informatie hierover kan je verkrijgen bij de fabrikant van je browser. Als je cookies uitschakelt, is het mogelijk
            dat bepaalde functies niet werken of dat bepaalde diensten niet beschikbaar voor je zijn.
          </p>
          <p>
            <a href="https://www.nibhv.nl/download/5021/" target="_blank">
              Download hier het privacy- en cookiebeleid van NIBHV.
            </a>
          </p>
          <p>Via deze website kunnen de volgende soorten cookies geplaatst worden:</p>

          <p>
            <strong>Functionele cookies</strong>
            <br />
            Deze cookies zijn noodzakelijk voor het overbrengen van communicatie en/of voor de verlening van de diensten waarom je vraagt. Ze worden gebruikt om de
            website gebruiksvriendelijker te maken door bepaalde voorkeuren op te slaan, bijvoorbeeld om te onthouden dat je ingelogd bent, dat je toestemming heeft
            gegeven voor het plaatsen van cookies, dat je bepaalde pagina’s reeds bekeken hebt, dat je meegedaan hebt aan een onderzoek, of om bepaalde voorkeuren voor de
            weergave vast te houden.
          </p>
          <p>
            <strong>Cookies voor het tonen van gerichte advertenties</strong>
            <br />
            NIBHV maakt gebruik van advertentienetwerken om advertenties te tonen op bepaalde plekken in de website. Daarnaast kunnen bepaalde specifieke technieken als
            retargeting en real-time bidding ingezet worden om bezoekers die bepaalde pagina’s van deze website hebben bezocht opnieuw te bereiken via gerichte
            advertenties op websites van derden. Om deze advertenties zo goed mogelijk te kunnen afstemmen op je interesses worden cookies gebruikt. De gegevens die in
            deze cookies worden opgeslagen zijn volledig anoniem.
          </p>
          <p>
            <strong>Cookies voor website analyse</strong>
            <br />
            NIBHV maakt gebruik van analytische cookies. Deze worden door NIBHV gebruikt om te analyseren hoe je de websites gebruikt. De door de cookie gegenereerde
            informatie over het gebruik van de websites (met inbegrip van jouw IP-adres) wordt overgebracht naar en opgeslagen door derden.
          </p>
          <p>
            <strong>Overige cookies</strong>
            <br />
            De website(s) van NIBHV kunnen mediabestanden van websites van derden zoals bijvoorbeeld Youtube.com bevatten. Bij het afspelen van deze mediabestanden kunnen
            door deze derden cookies geplaatst worden. Verder biedt deze website de optie om bepaalde informatie te delen via sociale netwerken als Facebook, LinkedIn of
            Twitter en Instagram. Bij gebruik van deze functionaliteit kunnen door deze sociale netwerken cookies op jouw computer worden geplaatst om bij te houden welke
            informatie gedeeld is.
          </p>

          <h2>Cookies verwijderen</h2>
          <p>
            Cookies worden opgeslagen op jouw computer en je kunt ze op elk gewenst moment verwijderen. Dat gaat heel eenvoudig. Klik op één van de onderstaande browsers
            om direct naar de handleiding van jouw browser te gaan. Bedenk wel dat je na het verwijderen van cookies op sommige websites opnieuw jouw voorkeuren zult
            moeten instellen of opnieuw moet inloggen.
          </p>
          <p>Cookies en sitegegevens beheren met de onderstaande browsers:</p>
          <ul>
            <li>
              <a href="https://support.google.com/chrome/answer/95647?hl=nl" target="_blank">
                Google Chrome
              </a>
            </li>
            <li>
              <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer#w_cookie-settings" target="_blank">
                Firefox
              </a>
            </li>
            <li>
              <a href="https://support.microsoft.com/nl-nl/products/windows?os=windows-10" target="_blank">
                Internet Explorer
              </a>
            </li>
            <li>
              <a href="https://support.apple.com/kb/PH5042?locale=nl_NL" target="_blank">
                Safari
              </a>
            </li>
          </ul>
          <p>
            Je hebt altijd het recht een klacht over de verwerking van je persoonsgegevens in te dienen bij de Autoriteit Persoonsgegevens of bij de rechter. Meer
            informatie daarover vind je hier.
          </p>

          <h2>Beveiliging en bewaartermijn</h2>
          <p>
            NIBHV heeft passende technische en organisatorische maatregelen getroffen om jouw persoonsgegevens te beschermen tegen verlies of enige andere vorm van
            onrechtmatige verwerking. NIBHV bewaart jouw gegevens niet langer dan wettelijk is toegestaan, wettelijk verplicht is en/of noodzakelijk is voor de doeleinden
            waarvoor de gegevens worden verwerkt. Hoe lang bepaalde gegevens worden bewaard is afhankelijk van de aard van de gegevens en de doeleinden waarvoor zij
            worden verwerkt. De bewaartermijn kan dus per doel verschillen.
          </p>
          <h2>Inzage, correctie en verwijdering</h2>
          <p>
            Je hebt het recht ons te verzoeken inzage te geven in welke persoonsgegevens we van jou verwerken. Ook kan je om rectificatie of wissing van die
            persoonsgegevens vragen, of om beperking van de verwerking van die gegevens. Daarnaast heb je het recht tegen verwerking van je persoonsgegevens bezwaar te
            maken en het recht op overdraagbaarheid van jouw gegevens. Je kan daarvoor een bericht sturen, met je naam en contactgegevens aan NIBHV, Postbus 8714, 3009 AS
            Rotterdam of een e-mail sturen aan info@nibhv.nl. In je verzoek moet je zoveel mogelijk specificeren om welke persoonsgegevens het gaat. Wij zullen binnen
            vier weken op een verzoek reageren. In geval van een verzoek tot verwijdering zullen wij de betreffende persoonsgegevens zo spoedig mogelijk verwijderen,
            tenzij, en voor zover, de wet ons verplicht om de betreffende persoonsgegevens te bewaren of er andere dringende redenen zijn die zich tegen verwijdering
            verzetten. Wij sturen je na uitvoering van een verzoek tot verwijdering een bevestigingsbericht. Als we de betreffende persoonsgegevens (gedeeltelijk) niet
            hebben verwijderd, sturen we je een bericht waarin we toelichten waarom niet (volledig) aan je verzoek kon worden voldaan. Als we niet of niet volledig kunnen
            vaststellen op welke persoonsgegevens je verzoek betrekking heeft, kunnen we je vragen om je verzoek nader te specificeren. We schorten dan de uitvoering van
            het verzoek op totdat je ons de nadere specificatie hebt verstrekt.
          </p>
          <p>
            Je hebt altijd het recht een klacht over de verwerking van je persoonsgegevens in te dienen bij de Autoriteit Persoonsgegevens of bij de rechter. Meer
            informatie daarover vind je hier.
          </p>
          <h2>Wijziging en versie</h2>
          <p>
            Wij kunnen dit privacy- en cookiebeleid wijzigen of aanpassen. We raden je daarom aan dit privacy en cookiebeleid regelmatig op wijzigingen na te lezen. Dit
            privacy- en cookiebeleid is voor het laatst gewijzigd op 1 januari 2020.
          </p>
          <p>
            Download hier{" "}
            <a href="https://www.nibhv.nl/wp-content/uploads/2018/05/Standpunt-verwerkersovereenkomsten-NIBHV.pdf">
              standpunt NIBHV verwerkersovereenkomsten met opleiders
            </a>
          </p>
        </div>

        <button className="btn btn-primary" onClick={() => history.go(-1)}>
          Terug
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/Privacy.js